import { render, staticRenderFns } from "./statisticalAnalysis.vue?vue&type=template&id=96bc3bae&scoped=true"
import script from "./statisticalAnalysis.vue?vue&type=script&lang=js"
export * from "./statisticalAnalysis.vue?vue&type=script&lang=js"
import style0 from "./statisticalAnalysis.vue?vue&type=style&index=0&id=96bc3bae&prod&scoped=true&lang=css"
import style1 from "./statisticalAnalysis.vue?vue&type=style&index=1&id=96bc3bae&prod&lang=scss"
import style2 from "./statisticalAnalysis.vue?vue&type=style&index=2&id=96bc3bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bc3bae",
  null
  
)

export default component.exports